import { fg } from '@atlassian/jira-feature-gating';
import type { State, UIState } from '../../types';
import { AccessTokenModalType } from '../access-token';
import { LOCALES, TIMEZONES } from '../date';
import { DEFAULT } from '../import-type';
import { ProjectTypes } from '../project';
import { PROJECT_CREATE } from '../source';
import { SELECT_PRODUCT_STEP, SELECT_SOURCE_STEP } from '../steps';

export const DEFAULT_DATE_FORMAT = 'dd/MMM/yy h:mm a';
export const DEFAULT_LOCALE = LOCALES[0];
export const DEFAULT_TIMEZONE = TIMEZONES[TIMEZONES.length - 1];

const getInitialState = (): State => ({
	sourceItems: null,
	importType: DEFAULT,
	step: fg('enable-x2c-standardised-flow') ? SELECT_SOURCE_STEP : SELECT_PRODUCT_STEP,
	mappingState: null,
	migrationId: null,
	uploadedFileName: null,
	advancedOptions: {
		dateFormat: DEFAULT_DATE_FORMAT,
		fileEncoding: 'UTF-8',
		delimiter: ',',
		timeZoneOption: DEFAULT_TIMEZONE,
		localeOption: DEFAULT_LOCALE,
	},
	projectData: {
		name: '',
		key: '',
		type: fg('enable-x2c-standardised-flow') ? null : ProjectTypes.BUSINESS,
		style: null,
		accessLevel: undefined,
		template: undefined,
	},
	thirdPartyState: {
		workspaces: null,
		spaces: null,
		folders: null,
		subfolders: null,
		entities: null,
		entityStats: null,
		selectedEntities: null,
		selectedEntityId: null,
		selectedWorkspaceId: null,
		selectedSpaceId: null,
		selectedSpaceName: null,
		selectedFolderId: null,
		selectedSubfolderId: null,
		siteName: null,
		members: null,
		userEmails: {},
		thirdPartyFieldConfigState: null,
		thirdPartyImportSettings: {
			shouldImportAttachments: true,
			shouldImportComments: true,
			shouldImportUsers: true,
		},
		thirdPartyStatusMapping: null,
	},
	source: PROJECT_CREATE,
});

export const INITIAL_STATE: State = getInitialState();

export const INITIAL_UI_STATE: UIState = {
	hasUnsavedFieldMappingChanges: false,
	hasUnsavedHierarchyMappingChanges: false,
	hasUnsavedStatusMappingChanges: false,
	cancelModal: {
		isCancelImportModalOpen: false,
		shouldCloseDrawerOnCancel: true,
	},
	accessTokenModal: {
		isModalOpen: false,
		modalType: AccessTokenModalType.ADD_NEW_TOKEN,
	},
};
